export default "__VITE_ASSET__C3t4f0hn__"